<template>
  <v-form
    ref="form"
    v-model="valid"
    lazy-validation
    @submit.prevent="updateCrowdedTrainRegistration"
  >
    <v-card>
      <v-card-title primary-title>
        Redigera kommentar
      </v-card-title>

      <v-card-text>
        <v-container>
          <v-row>
            <v-col>
              <v-textarea
                filled
                label="Kommentar"
                v-model="model.comment_admin"
                placeholder="Kommentar..."
              />
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn tile text @click="close" :disabled="pendingUpdate">
          Avbryt
        </v-btn>
        <v-btn tile color="primary" text type="submit" :loading="pendingUpdate">
          Uppdatera
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-form>
</template>

<script>
import gql from 'graphql-tag'

export default {
  name: 'CrowdedTrainRegistrationEdit',

  data: () => ({
    pendingUpdate: false,
    valid: true,
    model: {
      comment_admin: null,
      id: null
    }
  }),

  props: {
    registration: Object
  },

  created() {
    this.model.comment_admin = this.registration.comment_admin
    this.model.id = this.registration.id
  },

  methods: {
    close() {
      this.$emit('close')
    },

    async updateCrowdedTrainRegistration() {
      const isValid = await this.$refs.form.validate()

      if (!isValid) return

      this.pendingUpdate = true

      await this.$apollo.mutate({
        mutation: gql`
          mutation updateCrowdedTrainRegistation(
            $input: UpdateCrowdedTrainRegistationInput!
          ) {
            updateCrowdedTrainRegistation(input: $input)
          }
        `,

        variables: {
          input: this.model
        }
      })

      this.pendingUpdate = false
      this.$emit('confirm')
    }
  }
}
</script>
